import React, { useContext } from "react";
import { Link } from "react-router-dom";
import logo from "../img/logo.png";

import { CiHeart } from "react-icons/ci";
import { TiShoppingCart } from "react-icons/ti";
import "./Header.css";
import { CartContext } from "../Componinets/Context/CartContext";
import SerashBox from "../Page/SerashBox";

function TopHeader() {
  let { cartitem, favorites } = useContext(CartContext);

  return (
    <div className="Top-Header">
      <div className="Container">
        <Link className="logo" to="/">
          <img src={logo} alt="logo" />
        </Link>

        <SerashBox />
        <div className="header-icon">
          <div className="icon">
            <Link to="/Favorites">
              <CiHeart />
              <span className="cuont">{favorites.length}</span>
            </Link>
          </div>
          <div className="icon">
            <Link to="/Cart">
              <TiShoppingCart />
              <span className="cuont">{cartitem.length}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopHeader;
